import { FC } from 'react';

import { Control, Controller, FieldError } from 'react-hook-form';

import { ICustomRadioSelectorProps } from '../CustomRadioSelector/types';

import { CustomRadioSelector } from '../CustomRadioSelector';

interface IControlledCustomRadioSelectorProps
  extends Omit<ICustomRadioSelectorProps, 'error'> {
  control: Control<any, any>;
  name: string;
  error?: FieldError;
}

export const ControlledCustomRadioSelector: FC<
  IControlledCustomRadioSelectorProps
> = ({ control, name, error, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        const handleChange = (option: string): void => {
          onChange?.(option);
          props.onChange?.(option);
        };

        return (
          <CustomRadioSelector
            {...props}
            value={value}
            error={error?.message || ''}
            onChange={handleChange}
          />
        );
      }}
    />
  );
};
